import { render, staticRenderFns } from "./DocumentInformation.vue?vue&type=template&id=d8bb3ab6&"
import script from "./DocumentInformation.vue?vue&type=script&lang=js&"
export * from "./DocumentInformation.vue?vue&type=script&lang=js&"
import style0 from "./DocumentInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports